<template>
  <div class="bg-purple-light">
    <div class="content">
      <Navbar is-logged-in />

      <div class="d-flex justify-content-center">
        <div class="white-box my-5 mx-3">
          <div class="m-3 p-4">
            <p class="text-one mb-2">
              <strong>
                {{ $t("instruction-page.text-one") }}
              </strong>
            </p>
            <p class="text-two mb-2">
              <strong>
                Fit Daily Monitoring
              </strong>
            </p>
            <p class="text-three pb-4 mb-4">
              {{ $t("instruction-page.text-three") }}
            </p>
            <p class="text-four mb-4">
              {{ $t("instruction-page.text-four.one") }}
              <strong>{{ $t("instruction-page.text-four.two") }}</strong>
              {{ $t("instruction-page.text-four.three") }}
            </p>
            <p class="text-five m-0">
              {{ $t("instruction-page.text-five") }}
            </p>
            <form>
              <div
                v-if="!user.hrisEmpId"
                class="mt-4"
              >
                <div class="text-label mb-1">
                  {{ $t("instruction-page.form.label.nric") }}
                </div>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span
                      class="input-group-text"
                    ><i
                      class="fa fa-id-card"
                      aria-hidden="true"
                    /></span>
                  </div>
                  <input
                    v-model="form.nric"
                    class="form-control form-control-sm"
                    :placeholder="$t('instruction-page.form.placeholder.nric')"
                  >
                </div>
              </div>

              <div class="status mt-4">
                <p class="text-label mb-1">
                  {{ $t("instruction-page.form.label.status") }}
                </p>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span
                      class="input-group-text"
                    ><i
                      class="fa fa-user"
                      aria-hidden="true"
                    /></span>
                  </div>
                  <v-select
                    v-model="$v.form.status.$model"
                    class="sm"
                    :placeholder="$t('instruction-page.form.placeholder.status')"
                    :label="`name${$i18n.locale.toUpperCase()}`"
                    :options="workStatuses"
                    :clearable="false"
                    :reduce="({ id }) => id"
                  />
                </div>
                <div class="invalid-css mb-3">
                  <span v-if="!$v.form.status.required && $v.form.status.$error">{{
                    $t("instruction-page.form-error.status-required")
                  }}</span>
                </div>

                <div class="location mt-4">
                  <p class="text-label mb-1">
                    {{ $t("instruction-page.form.label.location") }}
                  </p>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span
                        class="input-group-text"
                      ><i
                        class="fa fa-map-marker"
                        aria-hidden="true"
                      /></span>
                    </div>
                    <v-select
                      v-model="$v.form.location.$model"
                      class="sm"
                      label="name"
                      :placeholder="$t('instruction-page.form.placeholder.location')"
                      :options="workLocations"
                      :clearable="false"
                      :reduce="({ id }) => id"
                      :selectable="option => !option.hasOwnProperty('group')"
                    >
                      <template #option="{ group, name }">
                        <div v-if="group">
                          {{ group }}
                        </div>
                        {{ name }}
                      </template>
                    </v-select>
                  </div>
                  <div class="invalid-css mb-3">
                    <span v-if="!$v.form.location.required && $v.form.location.$error">{{
                      $t("instruction-page.form-error.location-required")
                    }}</span>
                  </div>
                </div>
              </div>
            </form>
            <div class="button text-center">
              <div
                class="next"
                @click="nextScreen()"
              >
                {{ $t("instruction-page.button-next") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VSelect from 'vue-select'
import { isToday } from 'date-fns'
import {
  required
} from 'vuelidate/lib/validators'
import api from '@/utils/Api'
import Navbar from '@/components/Navbar'
import { SURVEY_ID } from '@/fixtures'

export default {
  name: 'Instruction',

  components: {
    VSelect,
    Navbar
  },

  props: {
    idAssessment: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      responseSurvey: {},
      user: JSON.parse(localStorage.getItem('profile')) || {},
      workLocations: [],
      workStatuses: [],
      form: {
        nric: null,
        status: null,
        location: null
      }
    }
  },
  watch: {
    '$i18n.locale' () {
      this.fetchWorkStatuses()
    },
    'form.location' (newLocationId) {
      if (newLocationId) {
        const profile = JSON.parse(localStorage.getItem('profile')) || {}
        profile.currentWorkLocationId = newLocationId
        localStorage.setItem('profile', JSON.stringify(profile))
      }
    }
  },

  // async beforeRouteEnter (to, from, next) {
  //   const { data } = await api.users.me()
  //   if (!to.params.edit && data.lastSubmissionDate && isToday(new Date(data.lastSubmissionDate))) {
  //     next(`/${to.params.lang}/my-assessment`)
  //   } else {
  //     next()
  //   }
  // },
  beforeRouteEnter (to, from, next) {
    api.users.me().then(({ data }) => {
      next(vm => {
        vm.user = data // simpan user ke data()
        if (!to.params.edit && data.lastSubmissionDate && isToday(new Date(data.lastSubmissionDate))) {
          vm.$router.push(`/${to.params.lang}/my-assessment`)
        }
      })
    })
  },

  created () {
    this.form.nric = this.user.nric || null
    this.fetchWorkLocations()
    this.fetchWorkStatuses()
  },

  async mounted () {
    const profile = JSON.parse(localStorage.getItem('profile')) || {}
    const savedLocation = profile.currentWorkLocation

    if (this.idAssessment) {
      await this.getResponseAssessment(this.idAssessment)
    }

    if (savedLocation) {
      this.form.location = savedLocation
    }
  },

  methods: {
    async getResponseAssessment (id) {
      const dataLoc = JSON.parse(localStorage.getItem('profile'))
      this.role = dataLoc.role.name
      const data = await api.surveys.getResponsesId(SURVEY_ID, id)

      if (this.workLocations.some(wl => wl.id === this.user.workLocationId)) {
        this.form.location = this.user.workLocationId
      }

      if (this.workStatuses.some(ws => ws.id === data.data.workStatus.id)) {
        this.form.status = data.data.workStatus.id
      }
    },
    async fetchWorkLocations () {
      const { data } = await api.masterData.workLocations({
        Filters: `companyId==${this.user.company ? this.user.company.id : ''}`
      })
      this.workLocations = data.data.reduce((acc, curr) => {
        const newGroup = (!acc.find(a => a.group === curr.category) &&
          [{ group: curr.category, name: null }]) ||
          []
        return [
          ...acc,
          ...newGroup,
          curr
        ]
      }, [])
      if (this.workLocations.some(wl => wl.id === this.user.workLocationId)) {
        this.form.location = this.user.workLocationId
      }
    },
    async fetchWorkStatuses () {
      const { data } = await api.masterData.workStatuses({
        Filters: `companyId==${this.user.company ? this.user.company.id : ''}`,
        Sorts: `name${this.$i18n.locale.toUpperCase()}`
      })
      this.workStatuses = data.data
      if (this.workStatuses.some(ws => ws.id === this.user.lastWorkStatusId)) {
        this.form.status = this.user.lastWorkStatusId
      }
    },
    saveMetaDraft () {
      localStorage.setItem('survey-meta', JSON.stringify(this.form))
    },
    nextScreen () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        if (this.idAssessment) {
          this.$router.push({
            name: 'edit-assessment',
            params: {
              idAssessment: this.idAssessment,
              workLocationId: this.form.location,
              workStatusId: this.form.status
            }
          })
        } else {
          this.saveMetaDraft()
          this.$router.push({
            name: 'self-assessment'
          })
        }
      }
    }
  },

  validations: {
    form: {
      status: {
        required
      },
      location: {
        required
      }
    }
  }
}
</script>

<style scoped>
.content {
  background-image: url('~@/assets/image/bg-2.png');
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: contain;
  min-height: 100vh;
}
.white-box {
  background: white;
  max-width: 404px;
  border-radius: 18px;
}
.white-box .text-one {
  color: #AAAAAA;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}
.white-box .text-two {
  color: #121212;
  font-family: Montserrat;
  font-size: 20px;
  line-height: 24px;
  text-align: left;
}
.white-box .text-three {
  color: #18B2BD;
  font-family: Montserrat;
  font-size: 14px;
  line-height: 17px;
  text-align: left;
  border-bottom: 2px solid #DEDEDE;
}
.white-box .text-four,
.white-box .text-five {
  color: #121212;
  font-family: Montserrat;
  font-size: 14px;
  line-height: 24px;
  text-align: justify;
  font-weight: 500;
}
.text-label {
  font-size: 12px;
  font-weight: bold;
  line-height: 14px;
}
.input-group-text {
  background-color: white;
  color: #18b2bd;
}
.text-input {
  font-weight: 600;
}
.text-input::-webkit-input-placeholder {
  font-weight: 600;
  font-size: 12px;
  color: #aaaaaa;
}
.text-dropdown {
  font-weight: 400;
  font-size: 14px;
  height: 32px;
}
.button {
  margin-top: 55px;
  padding-left: 15px;
  padding-right: 15px;
}
.button .next {
  background-color: #18B2BD;
  padding-top: 11px;
  padding-bottom: 11px;
  border-radius: 4px;
  color: white;
  cursor: pointer;
  transition: 0.5s;
  font-size: 12px;
  font-weight: 600;
}
.button .next:hover {
  background-color: #18b2bd8a;
}
.invalid-css {
  height: 10px;
  font-size: 12px;
  color: rgb(197, 0, 0);
}
</style>
